import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { IMAGE_BASE_URL } from '../../../core';

interface CategoriesProps {
  categories: {
    id: number;
    category_name: string;
    category_image: string;
    category_rate: Number;
    created_at: string;
    updated_at: string;
  }[];
  selectedCategory: number | null;
  onSelectCategory: (categoryId: number) => void;
}

export const Categories = (props: CategoriesProps) => {
  return (
    <Swiper
      modules={[Scrollbar, Navigation]}
      spaceBetween={0}
      slidesPerView={3.75}
      slidesPerGroup={1}
      navigation
      scrollbar={{
        hide: false
      }}
      className="text-sm">
      {props.categories.map((category) => {
        return (
          <SwiperSlide
            key={category.id}
            className="flex flex-col items-center pb-2 pt-2"
            style={{
              cursor: 'pointer',
              width: '100%'
            }}
            onClick={() => props.onSelectCategory(category.id)}>
            <div
              className="w-[90%] mb-1"
              style={{
                aspectRatio: 1,
                backgroundColor:
                  category.id === props.selectedCategory ||
                  (category.id === 1 && !props.selectedCategory)
                    ? 'var(--rs-primary-200)'
                    : 'transparent'
              }}>
              <img
                src={`${IMAGE_BASE_URL}/${category.category_image}`}
                alt={category.category_name}
              />
            </div>
            {category.category_name}
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};
